// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 在哪个组件上监听事件， 方法就该写在哪个组件上，但是如果方法里执行的是其他extendJS 里的方法，就不是自有方法
import { applyTrialOrgProbationPeriod } from '@/service/util'

import util from '@/tools/util'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      dialogTrialApplyVisible: false,

      trial_apply_org_loading: false,

      trialApplyOrg: {

      },

      trialApplyForm: {
        reason: ''
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {
    // for (const key in this.$refs) {
    //  this.$refs[key].$destroy()
    // }
  }, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
  methods: {
    /* 自有方法， 和其他不相关连的---- 在哪个组件上监听事件， 方法就该写在哪个组件上，但是如果方法里执行的是其他extendJS 里的方法，就不是自有方法 */
    handleCloseTrialApplyOrg () {
      this.dialogTrialApplyVisible = false
    },

    showTrialApplyOrgDialog () {
      this.dialogTrialApplyVisible = true
    },

    submitTrialApplyOrgMessage () {
      const trialApplyOrg = this.trialApplyOrg || {}

      const {
        id: org_id
      } = trialApplyOrg

      this.$refs.trialApplyForm.validate((valid) => {
        if (valid) {
          const trialApplyForm = this.trialApplyForm || {}

          const {
            reason,
            invitation_code
          } = trialApplyForm

          const params = {
            infos: {
              reason
            },
            org_id
          }

          if (invitation_code) {
            params.invitation_code = invitation_code
          }

          this.trial_apply_org_loading = true
          applyTrialOrgProbationPeriod((res) => {
            this.dialogTrialApplyVisible = false

            this.trial_apply_org_loading = false

            this.$message({
              type: 'success',
              message: '你的申请已提交，稍后会有客户经理联系您',
              customClass: 'manban-toast__success'
            })
          }, {
            ...params
          }, () => {
            this.trial_apply_org_loading = false
          })
        } else {
          this.$message({
            type: 'error',
            message: '带 * 号为必填项',
            customClass: 'manban-toast__error'
          })
        }
      })
    },

    // 限制邀请码输入
    hanldeLimitInvitationCode (val) {
      const max_val_len = 4

      if (val) {
        val = val.slice(0, max_val_len)
      }

      util.limitIntegetInput(val, (new_val) => {
        this.$set(this.trialApplyForm, 'invitation_code', new_val)
      }, (new_val) => {
        this.$set(this.trialApplyForm, 'invitation_code', new_val)
      })
    },
    /* 当前页面 功能事件函数复用方法 */

    // 初始化试用申请表单数据
    initTrialApplyFormRelationData () {
      this.trialApplyForm = {
        reason: '',
        invitation_code: ''
      }

      console.log(this.trialApplyForm, 'this.trialApplyForm')
    }
  }
}
